// 게임설정
import LayoutGameSetup from "./LayoutGameSetup"

export default { 
  path:'game-setup/:game_code', 
  element:<LayoutGameSetup />,
  children:[
    { // 기본 정보 
      index:true,
      handle:{label:'기본정보'},
      lazy: async ()=>({Component:(await import('./setup_info')).default })
    }, 
    { // 기본 정보 
      path:'setup-info',
      handle:{label:'기본정보'},
      lazy: async ()=>({Component:(await import('./setup_info')).default })
    },
    { // 등급관리
      path:'setup-type',
      handle:{label:'등급관리'},
      lazy: async ()=>({Component:(await import('./setup_type')).default })
    },
    { // 신청관리
      path:'registration',
      handle:{label:'신청관리'},
      lazy: async ()=>({Component:(await import('./registration')).default })
    },
    { // 경기설정
      path:'setup-race',
      handle:{label:'경기설정'},
      lazy: async ()=>({Component:(await import('./setup_race')).default })
    },
    { // 경기설정
      path:'setup-race/:type_idx',
      handle:{label:'경기설정'},
      lazy: async ()=>({Component:(await import('./setup_race')).default })
    },
    { // 경기진행
      path:'manage-race',
      handle:{label:'경기진행'},
      lazy: async ()=>({Component:(await import('./manage_race')).default })
    },
    { // 경기 진행
      path:'manage-race/:type_idx',
      handle:{label:'경기진행'},
      lazy: async ()=>({Component:(await import('./manage_race')).default })
    },
  
  ]
}